import React from 'react';
import MasonryDefault, { ResponsiveMasonry } from 'react-responsive-masonry';
import { ReadingCard } from './LiveReadingCard/ReadingCard';
import { IAppliance } from '../../types/Appliance/Appliance';
import { IDataPoint } from '../../types/DataPoint/DataPoint';

const Masonry = MasonryDefault as unknown as React.ComponentType<any>;
const Responsive = ResponsiveMasonry as unknown as React.ComponentType<any>;

interface ReadingsCardsProps {
  dataPoints: IDataPoint[];
  selectedAppliance: IAppliance;
  timestamp: string;
}

export function ReadingsCards({
  dataPoints,
  selectedAppliance,
  timestamp,
}: ReadingsCardsProps) {
  return (
    <Responsive
      gutterBreakPoints={{ 0: '1.2rem' }}
      columnsCountBreakPoints={{ 0: 1, 768: 2 }}
    >
      <Masonry gutter="1.2rem">
        {dataPoints.map((dp) => (
          <ReadingCard
            key={dp.id}
            appliance={selectedAppliance}
            timestamp={timestamp}
            dataPoint={dp}
          />
        ))}
      </Masonry>
    </Responsive>
  );
}
